import React, { PropTypes, Component } from 'react';
import styled from 'styled-components';

const TabsContainer = styled.div`
  display: flex;
`;

const Tab = styled.div`
  text-transform: uppercase;
  position: relative;
  display: flex;
  cursor: pointer;
  letter-spacing: 0.4px;
  align-items: center;
  padding: 11px 20px;
  font-size: 12px;
  font-family: ${props => props.theme.font.bold};
  color: ${props =>
    props.active ? props.theme.color.primary : props.theme.color.brownGrey};
  background: ${props =>
    props.active ? `${props.theme.color.primary}1A` : ''};

  &:hover {
    background: ${props => props.theme.color.primary}1A;
    color: ${props => props.theme.color.primary};
  }

  &:after {
    display: ${props => (props.active ? 'block' : 'none')};
    background: ${props => props.theme.color.primary};
    content: '';
    position: absolute;
    left: 0;
    width: 100%;
    bottom: 0;
    height: 4px;
  }
`;

/**
 * This component will display a list of tabs and call back when a tab is clicked
 */
class Tabs extends Component {
  render() {
    return (
      <TabsContainer>
        {this.props.tabs.map(tab => (
          <Tab
            key={tab.id}
            active={tab.id === this.props.activeKey}
            onClick={() => this.props.onClick(tab)}>
            {tab.title}
          </Tab>
        ))}
      </TabsContainer>
    );
  }
}

Tabs.propTypes = {
  // A list of tabs
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired
    })
  ),

  // A activeKey matched against a tab ID to determine what the active tab is
  activeKey: PropTypes.string.isRequired,

  onClick: PropTypes.func
};

Tabs.defaultProps = {
  tabs: [],
  onClick: () => {}
};

export default Tabs;



// WEBPACK FOOTER //
// ./src/components/common/tabs/index.js